"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "card-requirement" };
const _hoisted_2 = { key: 1 };
const _hoisted_3 = {
    key: 3,
    class: "card-production-box card-production-box--req"
};
const _hoisted_4 = { class: "card-production-box-row" };
const _hoisted_5 = { class: "card-production-box-row-item" };
const _hoisted_6 = { class: "card-item-container" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CardParty = (0, vue_1.resolveComponent)("CardParty");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", {
            class: (0, vue_1.normalizeClass)(["card-item-container", _ctx.nextTo])
        }, [
            (_ctx.requirement.max)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, [
                    (0, vue_1.createTextVNode)("max ")
                ], 64))
                : (0, vue_1.createCommentVNode)("", true),
            (!_ctx.isRepeated)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_2, (0, vue_1.toDisplayString)(_ctx.amount), 1))
                : (0, vue_1.createCommentVNode)("", true),
            (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.suffix) + " ", 1),
            (_ctx.type === _ctx.RequirementType.REMOVED_PLANTS)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 2 }, [
                    _cache[0] || (_cache[0] = (0, vue_1.createElementVNode)("div", { class: "card-special card-minus" }, null, -1)),
                    _cache[1] || (_cache[1] = (0, vue_1.createElementVNode)("div", { class: "card-resource card-resource-plant red-outline" }, null, -1))
                ], 64))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.type === _ctx.RequirementType.PRODUCTION)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, [
                    (0, vue_1.createElementVNode)("div", _hoisted_4, [
                        (0, vue_1.createElementVNode)("div", _hoisted_5, [
                            (0, vue_1.createElementVNode)("div", _hoisted_6, [
                                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.repeats, (num) => {
                                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                        class: (0, vue_1.normalizeClass)(_ctx.productionClass),
                                        key: num
                                    }, null, 2));
                                }), 128))
                            ])
                        ])
                    ])
                ]))
                : (_ctx.type === _ctx.RequirementType.PARTY)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardParty, {
                        key: 4,
                        party: _ctx.party,
                        size: "req"
                    }, null, 8, ["party"]))
                    : ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 5 }, (0, vue_1.renderList)(_ctx.repeats, (num) => {
                        return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            key: num,
                            class: (0, vue_1.normalizeClass)(_ctx.componentClasses)
                        }, null, 2));
                    }), 128))
        ], 2)
    ]));
}
